const form = {
  formId: "tax-personal-05",
  formField: {
    year: {
      name: "year",
      label: "[01] Năm",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng nhập năm",
    },
    declarationTime: {
      name: "declarationTime",
      label: "[02] Kê khai lần thứ",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng nhập lần kê khai",
    },

    taxpayerName: {
      name: "taxpayerName",
      label: "[03] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId1: {
      name: "taxId1",
      label: "[04] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[05] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province: {
      name: "province",
      label: "[07] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district: {
      name: "district",
      label: "[06] Quận/Huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    phone: {
      name: "phone",
      label: "[08] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[09] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[10] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[11] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[12] Mã số thuế đại lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address2: {
      name: "address2",
      label: "[13] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province2: {
      name: "province2",
      label: "[15] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district2: {
      name: "district2",
      label: "[14] Quận/Huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    phone2: {
      name: "phone2",
      label: "[16] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax2: {
      name: "fax2",
      label: "[17] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email2: {
      name: "email2",
      label: "[18] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[19] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập hợp đồng đại lý thuế",
    },
    date: {
      name: "date",
      label: "[20] Ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập hợp đồng đại lý thuế",
    },
    organ1: {
      name: "organ1",
      label: "[21] Cơ quan thuế cấp cục",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế cấp cục",
    },
    organ2: {
      name: "organ2",
      label: "[22] Cơ quan thuế quản lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế quản lý",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên nhân viên đại lý thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
